<template lang="pug">
.crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
  modal-import(model="warehouse_receptions")
  modal-warehouse-receptions(:form='purchase', :details='details')
  .container-fluid
    vm-row( class="details" vm-w="12")
      vm-col(class="details__titles" vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.warehouse_receptions') }}:
          span {{ $t('strings.description', {attribute: $t('strings.warehouse_receptions')}) }}
        div(style="display:none;")
          vm-button(type="default" icon="list")
          vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(max-items="1" pagination v-model="selected"  max-height="350px" :data="purchaseOrders" )
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(class="details__search" ref="search" icon="search" size="small" placeholder="Buscar por Folio" v-model="searchFolio" @keyup.enter="onSearch()" width="300px")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column != 'status' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
                vm-status-indicator(v-if="column == 'status'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status']}}
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        details-receptions(@onConfirm="onConfirm")

</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('WarehouseReceptions')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalWarehouseReceptions = () => import('@/components/modals/ModalWarehouseReceptions.vue')
const DetailsReceptions = () => import('@/components/purchase-order/DetailsReceptions.vue')

export default {
  name: 'WarehouseReceptions',
  components: {
    ModalImport,
    ModalWarehouseReceptions,
    DetailsReceptions
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['folio', 'project_display', 'supplier_display', 'user_display', 'status'],
    columnsOrderBy: ['folio', 'email'],
    attributeModal: 'folio',
    status: [],
    purchase: {},
    details: [],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        folio: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    searchFolio: ''
  }),
  computed: {
    ...mapGetters(['purchaseOrders'])
  },
  async created () {
    if (this.$route.params.folio) {
      this.searchFolio = this.$route.params.folio
      this.loadPurcharse({ param: `${this.searchFolio},folio` })
    } else {
      this.setReceptions([])
    }
  },
  methods: {
    ...mapActions([
      'loadPurcharse',
      'setReceptions',
      'setModalVisible'
    ]),
    colorStatus (code) {
      switch (code) {
        case 'sended':
          return 'danger'
        case 'partially_stocked':
          return 'primary'
        case 'completed':
          return 'success'
        default:
      }
      return code.trim() === 'sended' ? 'success' : '#afbbc6'
    },
    onConfirm (data) {
      this.purchase = data.purchase
      this.details = data.detail
      this.setModalVisible(true)
    },
    onSearch () {
      this.loadPurcharse({ param: `${this.searchFolio},folio` })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
